import React, { useState, useEffect } from "react";
import axios from "axios";
import Pagination from "react-js-pagination";
import { Link } from "react-router-dom";
import { handleSortChange } from "../../utils/functions";
import TableSort from "../TableSort/TableSort";
import Tooltip from "../Tooltip/Tooltip";
import Spinner from "../Spinner/Spinner";

export default function ByCommodity(props) {
  const { regionKey, countyKey } = props;

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [totalRecords, setTotalRecords] = useState();
  const [data, setData] = useState([]);
  const [childData, setChildData] = useState();
  const [stateLoaded, setStateLoaded] = useState(false);
  const [key, setKey] = useState(null);
  const [kind, setKind] = useState(null);
  const [printMode, setPrintMode] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let sortData = handleSortChange(childData, true);
    (() => {
      if (regionKey) {
        setKey(regionKey);
        setKind("commoditybyregion");
      } else {
        setKey(countyKey);
        setKind("commoditybycounty");
      }
      axios.get(`/wp-json/${kind ? kind : null}/v1?url_key=${key ? key : null}&sort_by=${sortData.sortBy}&sort_dir=${sortData.sortDir}&page=${printMode ? 1 : page}&limit=${printMode ? totalRecords : limit}`)
        .then(res => res.data)
        .then(data => {
          const dataMap = new Map();
          Object.entries(data).map(entry => entry[1]).slice(0, -2).forEach(entry => {
            const existingEntry = dataMap.get(entry.CommodityName);
            if (existingEntry) {
              existingEntry.ImportTEUs = (parseFloat(existingEntry.ImportTEUs) + parseFloat(entry.ImportTEUs)).toFixed(2);
              existingEntry.ExportTEUs = (parseFloat(existingEntry.ExportTEUs) + parseFloat(entry.ExportTEUs)).toFixed(2);
              existingEntry.TotalTEUs = (parseFloat(existingEntry.TotalTEUs) + parseFloat(entry.TotalTEUs)).toFixed(2);
              existingEntry.ImportSTONS = (parseFloat(existingEntry.ImportSTONS) + parseFloat(entry.ImportSTONS)).toFixed(2);
              existingEntry.ExportSTONS = (parseFloat(existingEntry.ExportSTONS) + parseFloat(entry.ExportSTONS)).toFixed(2);
              existingEntry.TotalSTONS = (parseFloat(existingEntry.TotalSTONS) + parseFloat(entry.TotalSTONS)).toFixed(2);
            } else {
              dataMap.set(entry.CommodityName, entry);
            }
          });
          const summedDataArray = Array.from(dataMap.values());
          setData(summedDataArray);
          if (printMode) {
            window.print();
            setPrintMode(false);
            setLoading(false);
          } else {
            setStateLoaded(true)
            setTotalRecords(data.total)
          }
        })
        .catch(e => e)
    })();
  }, [childData, page, regionKey, countyKey, limit, kind, key, printMode, totalRecords])

  const handlePrint = () => {
    setPrintMode(true);
    setLoading(true);
  }

  useEffect(() => {
    if (regionKey) {
      props.sendToParent(totalRecords);
    }
  }, [regionKey, props, totalRecords]);

  const handlePaginationClick = (pageNumber) => {
    setPage(pageNumber);
  };
  const handleSelectValue = (e) => {
    setLimit(Number(e.target.value));
  };

  return (
    <>
      <div className='print-btn-wrapper'>
        {loading ? <Spinner /> : <button id='prnt-btn' className='print-btn' onClick={handlePrint}>
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.46875 9.28125C0.59307 9.28125 0.712299 9.33064 0.800206 9.41854C0.888114 9.50645 0.9375 9.62568 0.9375 9.75V12.0938C0.9375 12.3424 1.03627 12.5808 1.21209 12.7567C1.3879 12.9325 1.62636 13.0312 1.875 13.0312H13.125C13.3736 13.0312 13.6121 12.9325 13.7879 12.7567C13.9637 12.5808 14.0625 12.3424 14.0625 12.0938V9.75C14.0625 9.62568 14.1119 9.50645 14.1998 9.41854C14.2877 9.33064 14.4069 9.28125 14.5312 9.28125C14.6556 9.28125 14.7748 9.33064 14.8627 9.41854C14.9506 9.50645 15 9.62568 15 9.75V12.0938C15 12.591 14.8025 13.0679 14.4508 13.4196C14.0992 13.7712 13.6223 13.9688 13.125 13.9688H1.875C1.37772 13.9688 0.900806 13.7712 0.549175 13.4196C0.197544 13.0679 0 12.591 0 12.0938V9.75C0 9.62568 0.049386 9.50645 0.137294 9.41854C0.225201 9.33064 0.34443 9.28125 0.46875 9.28125Z" fill="#E8E8E8" />
            <path d="M7.16823 11.1131C7.21177 11.1568 7.2635 11.1914 7.32045 11.215C7.3774 11.2387 7.43845 11.2508 7.5001 11.2508C7.56176 11.2508 7.62281 11.2387 7.67976 11.215C7.73671 11.1914 7.78844 11.1568 7.83198 11.1131L10.6445 8.30063C10.7325 8.21261 10.7819 8.09323 10.7819 7.96875C10.7819 7.84427 10.7325 7.72489 10.6445 7.63688C10.5565 7.54886 10.4371 7.49941 10.3126 7.49941C10.1881 7.49941 10.0687 7.54886 9.98073 7.63688L7.96885 9.64969V1.40625C7.96885 1.28193 7.91947 1.1627 7.83156 1.07479C7.74365 0.986886 7.62442 0.9375 7.5001 0.9375C7.37578 0.9375 7.25656 0.986886 7.16865 1.07479C7.08074 1.1627 7.03135 1.28193 7.03135 1.40625V9.64969L5.01948 7.63688C4.93146 7.54886 4.81208 7.49941 4.6876 7.49941C4.56313 7.49941 4.44375 7.54886 4.35573 7.63688C4.26771 7.72489 4.21826 7.84427 4.21826 7.96875C4.21826 8.09323 4.26771 8.21261 4.35573 8.30063L7.16823 11.1131Z" fill="#E8E8E8" />
          </svg>
          Print
        </button>}
      </div>
      <div className="dashboard-table-container">
        <table className="all-table">
          <thead className='table-header-group'>
            <tr className="table-title">
              <th colspan="7">
                <div className="title-wrapper">
                  <span> ALL COMMODITIES </span>
                  <div className="sortby-wrapper">
                    <div className="sort-by">
                      <label for="items-per-page">Items per page: </label>
                      <select
                        id="per-page"
                        class="per-page-options"
                        onChange={handleSelectValue}
                      >
                        <option value="25" selected>
                          25
                        </option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                    </div>
                    <div className="sort-by">
                      <label for="sorter">Sort by: </label>
                      <TableSort
                        toChild={childData}
                        sendToParent={setChildData}
                        total={true}
                      />
                    </div>
                  </div>
                </div>
              </th>
            </tr>
            <tr className="table-subtitle level1">
              <th rowspan="2">COMMODITY</th>
              <th colspan="3">
                <Tooltip tooltipId="TEUs_tooltip" /> TEUS
              </th>
              <th colspan="3">
                <Tooltip tooltipId="TONs_tooltip" /> TONS
              </th>
            </tr>
            <tr className="table-subtitle level2">
              <th>Import</th>
              <th>Export</th>
              <th className="col-total">Total</th>
              <th>Import</th>
              <th>Export</th>
              <th lassName="col-total">Total</th>
            </tr>
          </thead>
          {stateLoaded ? (
            data.map((entry) => {
              return (
                <tr className="table-data-rows" key={entry.CommodityID}>
                  <td className="table-data-link">
                    <Link
                      to={{
                        pathname: "/overview/commodity",
                        state: {
                          commodityName: entry.CommodityName,
                          urlKey: entry.UrlKey,
                        },
                      }}
                    >
                      {entry.CommodityName}
                    </Link>
                  </td>
                  <td className="table-mobile-title">
                    TEUS <Tooltip tooltipId="TEUs_tooltip" />{" "}
                  </td>
                  <td className="table-data" data-title="Import">
                    {Math.round(Number(entry.ImportTEUs)).toLocaleString()}
                  </td>
                  <td className="table-data" data-title="Export">
                    {Math.round(Number(entry.ExportTEUs)).toLocaleString()}
                  </td>
                  <td className="table-data col-total" data-title="Total">
                    {Math.round(Number(entry.TotalTEUs)).toLocaleString()}
                  </td>
                  <td className="table-mobile-title">
                    TONS <Tooltip tooltipId="TONs_tooltip" />
                  </td>
                  <td className="table-data" data-title="Import">
                    {Math.round(Number(entry.ImportSTONS)).toLocaleString()}
                  </td>
                  <td className="table-data" data-title="Export">
                    {Math.round(Number(entry.ExportSTONS)).toLocaleString()}
                  </td>
                  <td className="table-data col-total" data-title="Total">
                    {Math.round(Number(entry.TotalSTONS)).toLocaleString()}
                  </td>
                </tr>
              );
            })
          ) : (
            <Spinner />
          )}
        </table>
      </div>
      <div className="dashboard-table-container">
        <Pagination
          activePage={page}
          totalItemsCount={totalRecords ? totalRecords : 200}
          itemsCountPerPage={limit}
          onChange={handlePaginationClick}
          prevPageText={"Previous"}
          nextPageText={"Next"}
          itemClass={"page-item"}
          itemClassFirst={"first-page"}
          itemClassLast={"last-page"}
          itemClassPrev={"prev"}
          itemClassNext={"next"}
        />
      </div>
    </>
  );
}
